import { axiosAuthHeader } from "config/axiosConfig";
import api from "../api";

export const userLogin = async (email: string, password: string, securityToken: string) => {
    return api.post(`/login`, { email, password, securityToken })
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}


export const initRecoveryPassword = async (email: string) => {
    return api.post(`/init-password-reset`,{ email })
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}

export const resendCode = async (email: string) => {
    return api.post(`/resend-invite`,{ email })
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}

export const finishRecoveryPassword = async (data: any) => {
    return api.post(`/password-reset`,{ ...data })
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}


export const userRegister = async (userData: any, securityToken: string) => {
    return api.post(`/account`, { ...userData, securityToken, })
        .then(res => {
            return res;
        })
        .catch((e) =>{
            return e;
        })
}

export const userConfirmAccount = async (userData: any) => {
    return api.post(`/account-confirm`, { ...userData })
        .then(res => {
            return res;
        })
        .catch((e) =>{
            return e;
        })
}

export const getUserProfile = async () => {
    // console.error("get profile");
    return api.get(`/profile?full=true`, axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}



export const updateUserProfile = async (userData: any) => {
    return api.post(`/profile`, { ...userData }, axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}

export const getUserBasicPortfolio = async () => {
    return api.get(`/basic-portfolio`, axiosAuthHeader())
        .then(res => {
            return res;
        })
        .catch(e =>{
            return e;
        })
}
